import { createContext, ReactNode, useState } from 'react'

import { ActionConfirmModal, ItemsRemoveConfirmModal } from 'src/components'
import { IItemsRemoveConfirmContext, IItemsRemoveConfirmModalValues } from 'src/types'

export const ItemsRemoveConfirmContext = createContext<IItemsRemoveConfirmContext>(
  {} as IItemsRemoveConfirmContext,
)

export interface IItemsRemoveConfirmProvider {
  children: ReactNode
}

const ItemsRemoveConfirmProvider = ({ children }: IItemsRemoveConfirmProvider) => {
  const [modalValues, setModalValues] = useState<IItemsRemoveConfirmModalValues | null>(null)
  const [isLoadingModal, setIsLoadingModal] = useState(false)

  const handleClose = () => {
    setModalValues(null)
  }

  return (
    <ItemsRemoveConfirmContext.Provider value={{ setModalValues, setIsLoadingModal }}>
      {children}
      {modalValues?.customModal ? (
        <ActionConfirmModal
          open={!!modalValues}
          handleClose={handleClose}
          handleConfirm={modalValues?.handleConfirm}
          itemsDetails={modalValues?.itemsDetails}
          customModal={modalValues.customModal}
          isLoadingModal={isLoadingModal}
        />
      ) : (
        <ItemsRemoveConfirmModal
          open={!!modalValues}
          handleClose={handleClose}
          itemsRelations={modalValues?.itemsRelations}
          itemsDetails={modalValues?.itemsDetails}
          itemsTitles={modalValues?.itemsTitles}
          handleConfirm={modalValues?.handleConfirm}
          itemsType={modalValues?.itemsType}
        />
      )}
    </ItemsRemoveConfirmContext.Provider>
  )
}

export { ItemsRemoveConfirmProvider }
